<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-clinic-medical</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("global.insurance") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.place") }}: {{ placeText }}<br />
      {{ $t("global.startDate") }}: {{ travelServiceOrderItem.insurance.start_date }}<br />
      {{ $t("global.endDate") }}: {{ travelServiceOrderItem.insurance.end_date }}<br />
    </div>
    <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
  </v-tooltip>
</template>

<script>
import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";
export default {
  name: "TravelServiceOrderItemInsuranceChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa hotelowa" }
  },
  data: () => ({
    placeText: ""
  }),
  watch: {
    "travelServiceOrderItem.hotel.place_id"() {
      this.downloadPlace();
    }
  },
  methods: {
    downloadPlace() {
      if (this.travelServiceOrderItem.insurance.place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.insurance.place_id }).then(result => {
          this.placeText = result.text;
        });
      }
    }
  },
  created() {
    this.downloadPlace();
  }
};
</script>

<style scoped></style>
